import axios from 'axios';

export const forceValidateTier = async (campaignId, tierId, payload = {}) => {
  const response = await axios.post(
    `/api/campaigns/${encodeURIComponent(campaignId)}/tiers/${encodeURIComponent(tierId)}/force-validate`,
    payload
  );
  return response.data;
};
